<template>
  <div class="columns is-centered">
    <div class="column is-12">
      <div class="field">
        <label class="label">
          Enter email address and we will send instructions how to reset your password
        </label>
        <div class="control">
          <input v-model="email" class="input" type="text" placeholder="Email">
        </div>
      </div>

      <div class="field">
        <div class="buttons">
          <button
            class="button is-primary"
            type="submit"
            @click.prevent="resetPassword"
          >
            Send Email
          </button>
          <button
            class="button is-outlined is-link"
            @click.prevent="backToLogin"
          >
            Back to Sign In
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FORGOT_PASSWORD from '@/graphql/user/forgotPassword.gql';

export default {
  name: 'ForgotPassword',
  data() {
    return {
      email: '',
    };
  },
  methods: {
    resetPassword() {
      this.$apollo.mutate({
        mutation: FORGOT_PASSWORD,
        variables: {
          email: this.email,
        },
      })
        .then(() => {
          this.$toasted.success('Email with instructions are sent.');
        })
        .catch((err) => {
          this.$toasted.error(err);
        });
    },
    backToLogin() {
      this.$emit('change-active-tab', 'login');
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
